import {ThumbsdownIcon, ThumbsupIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useRef, useState} from 'react'
import {NegativeFeedbackForm} from './NegativeFeedbackForm'
import type {FeedbackSubmitHandler} from './GroupsFeedback'
import type {ChangeGroupFeedbackOption} from '../../types/group-types'

interface FeedbackButtonProps {
  disabled: boolean
  onSubmit: FeedbackSubmitHandler
  feedbackOptions: ChangeGroupFeedbackOption[]
}

export function PositiveFeedbackButton({disabled, onSubmit}: Omit<FeedbackButtonProps, 'feedbackOptions'>) {
  return (
    <IconButton
      size="small"
      variant="invisible"
      disabled={disabled}
      icon={ThumbsupIcon}
      aria-label="Positive feedback"
      onClick={() => onSubmit({type: 'POSITIVE'})}
    />
  )
}

export function NegativeFeedbackButton({disabled, onSubmit, feedbackOptions}: FeedbackButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false)
  const returnFocusRef = useRef<HTMLButtonElement>(null)

  const handleSubmit: FeedbackSubmitHandler = args => {
    onSubmit(args)
    setDialogOpen(false)
  }

  return (
    <>
      {dialogOpen && (
        <NegativeFeedbackForm
          onClose={() => setDialogOpen(false)}
          onSubmit={handleSubmit}
          returnFocusRef={returnFocusRef}
          feedbackOptions={feedbackOptions}
        />
      )}
      <IconButton
        ref={returnFocusRef}
        size="small"
        variant="invisible"
        disabled={disabled}
        icon={ThumbsdownIcon}
        aria-label="Negative feedback"
        onClick={() => setDialogOpen(true)}
      />
    </>
  )
}
